import React from 'react';
import { styled } from '@mui/material/styles';

import { ToggleButtonGroup } from 'common/components/material';
import ToggleButton from 'common/components/material/ToggleButton';
import { InteractiveEndorsedSkillRatingProps, getAllRatings } from 'features/skills';

const RatingButton = styled(ToggleButton)(({ theme }) => ({
  ...theme.typography.body4,
  fontWeight: 500,
  color: theme.palette.Text.Headline,
  textTransform: 'none',
  '&.MuiToggleButtonGroup-grouped': {
    borderRadius: '8px',
    paddingTop: '0.5625rem',
    paddingBottom: '0.5625rem',
  },
  '&.MuiToggleButtonGroup-grouped.Mui-selected': {
    backgroundColor: theme.palette.Buttons.Primary.BgPressed,
    color: theme.palette.Buttons.Primary.LabelDefault,
  },
  '&:hover': {
    backgroundColor: theme.palette.Buttons.Tertiary.BgHover,
    color: theme.palette.LinkText.Active,
  },
}));

const InteractiveEndorsedSkillRating: React.FC<
  InteractiveEndorsedSkillRatingProps & { compact?: boolean }
> = ({ score, action, compact = false }) => {
  const ratings = getAllRatings();
  return (
    <ToggleButtonGroup
      value={score}
      fullWidth={!compact}
      exclusive
      onChange={action}
      sx={
        compact
          ? {
              width: 'auto',
              display: 'inline-flex',
              gap: 0.75,
            }
          : undefined
      }
    >
      {ratings.map((rating) => (
        <RatingButton
          key={rating.score}
          value={rating.score}
          sx={
            compact
              ? {
                  flex: '0 0 auto',
                  minWidth: 104,
                  minHeight: 30,
                  height: 30,
                  px: 1,
                  py: '2px',
                  fontSize: '0.7rem',
                  lineHeight: 1,
                  borderRadius: '6px !important',
                }
              : undefined
          }
        >
          {rating.label}
        </RatingButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default InteractiveEndorsedSkillRating;
